<template>
	<div>
		<BaseAccordionController :accordion_header="getStateWithParam('cctv_label')" :expand_accondion="true">
			<template v-slot:component>
				<MapCard :icon_url="icon_url" class="accordion-card-middle" :fitbounds="fitbounds">
					<l-marker
						v-for="marker in data_map.features"
						:key="'marker-' + marker.properties.title"
						:lat-lng="marker.geometry.coordinates"
						:icon="icon_url"
						@click="openCameraView(marker.properties.title)"
					></l-marker>
				</MapCard>
			</template>
		</BaseAccordionController>
		<v-dialog v-model="showdetails" persistent max-width="700">
			<v-card v-if="selectedcamera">
				<v-toolbar>
					<v-toolbar-title>{{ selectedcamera.address }}</v-toolbar-title>
					<v-btn icon @click="closeCameraDetails">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card-text class="camera-view-wrapper">
					<div
						v-if="cameraerror"
						class="camera-error-label">
						{{getStateWithParam('error_cctv_camera')}}
					</div>
					<!-- <v-img aspect-ratio="1.3333" :src="selectedcamera.img"  /> -->
					<img
						:src="selectedcamera.img"
						:alt="selectedcamera.address"
						class="camera-image"
						@error="setAltImg"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
//import MapCard from "@/components/cards/MapCardController.vue";
import MapCard from '@/components/cards/MapController.vue';
import { LMarker } from 'vue2-leaflet';
import trafic from '@/config/api/api_events/trafic.js';
import map_helper from '@/config/js_helper/map_helper';

export default {
	name: 'TraficView',
	components: {
		MapCard,
		LMarker,
	},
	props: {
		cameraid: {
			type: [String, Boolean],
			default: false,
		},
	},
	data() {
		return {
			from_where: 6,
			data_map: {
				features: [],
			},
			//icon_url: require("@/assets/img/new_icons/kamera.svg")
			icon_url: map_helper.getIcon(require('@/assets/img/new_icons/kamera.svg')),
			fitbounds: 0,
			cameraerror: false
		};
	},
	computed: {
		showdetails() {
			return this.cameraid !== false;
		},
		selectedcamera() {
			let camera = null;
			if (this.cameraid) {
				let foundcamera = this.data_map.features.find((item) => item.properties.title == this.cameraid);
				camera = foundcamera ? foundcamera.properties : null;
			}
			return camera;
		},
	},
	watch: {
		cameraid(id) {
			this.cameraerror = false
			this.$store.state.active_loader = false;
			/* if (!id) {
				this.selectedcamera = null
			} */
		},
	},
	mounted() {
		this.getLiveFotosFromTrafic();
	},
	methods: {
		getLiveFotosFromTrafic() {
			trafic
				.getMarkers()
				.then((response) => {
					this.data_map = response;
					this.fitbounds++;
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.$store.state.active_loader = false;
				});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		openCameraView(cameraid) {
			this.$router.push({ name: 'cctvitemdetails', params: { cameraid: cameraid } });
		},
		closeCameraDetails() {
			this.$router.push({name: 'cctv_label'});
		},
		setAltImg(event){
			this.cameraerror = true
			event.target.src = require('@/assets/img/camera-error.png')
		}
	},
};
</script>

<style scoped lang="scss" src="./TraficView.scss"></style>
